<template>
  <div class="container" @click="flagOn">
    <p v-if="pageLimit" class="limitInfo">
      {{`${locale.service_limit_page_3} ${locale.service_suggest_upgrade}`}}
    </p>
    <section id="editContent" :class="{columnContainer: true, adj: !newItem}">
      <div class="editorAdjust">
        <p class="deviceSize colorGrey">
          Divice size: {{getDeviceSize}}
          <button
            v-if="pageInfo.responsive === 'tablet'"
            type="button"
            class="rotateDevice"
            @click="setOrient(!orient ? 'portrait' : 'landscape')">
            <span class="blind">rotate device</span>
          </button>
        </p>
        <div v-if="!newItem" class="copyPageUrl">
          <span class="checkbox onoff">
            <input type="checkbox" id="check_frame" v-model="noFrame" @change="checkFrameMode">
            <label for="check_frame">{{noFrame ? locale.page_pageonly : locale.page_withsite}}</label>
          </span>
          <span :class="{urlInfo: true, copied: copied}" @click="copyToClipboard(id)">
            {{locale.page_copy_url}} <i class="lang">[{{locale['lang_' + langData.info.find(x => x.c === langData.current).c]}}]</i>
          </span>
        </div>
      </div>
      <Editor
        :locale="locale"
        :activeLang="langData.current"
        :langs="langData"
        :isNew="newItem"
        :itemModule="itemModule"
        :text="text"
        :responsive="pageInfo.responsive"
        :class="{hideGhost: displayHideModes}"
        :linkedProduct="linkedProduct"
        @update="updateModule"
        @changeColumn="updateColumn"
        @copyTo="copyToDevice" />
    </section>
    <button type="button" class="foldUi" :class="{active: isFold}" @click.stop="foldUi">{{isFold ? '&#8249;' : '&#8250;'}}</button>
    <div id="setContent" :class="{isFold: isFold}">
      <SetPageItem
        :locale="locale"
        :pageLimit="pageLimit"
        :info="pageInfo"
        :itemModule="itemModule"
        :langs="langData"
        :isNew="newItem"
        :isCopy="isCopy"
        :text="text"
        :submitData="submitPage"
        :currentVer="originVer"
        @updateResponsive="updateResponsive"
        @displayHideMods="displayHideMods"
        @uploadThumbnail="uploadThumbnail"
        @deleteThumbnail="deleteThumbnail"
        @updateLoadProduct="updateLoadProduct"
        @isLoadProduct="isLoadProduct"
        @updateNoTranslateLangs="updateNoTranslateLangs"
        @saveMemo="saveMemo"
        @loadVersion="loadVersion"
        @save="onSave" />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import UNIQUE from '@/common/unique'
import UTIL from '@/common/util'
import regExp from '@/common/regExp'
import Editor from '@/components/Editor/Index.vue'
import SetPageItem from '@/components/Page/SettingItem'
import modules from '@/components/Editor/ModuleData'

const defaultInfo = {
  title: 'New Page',
  pId: '',
  pIdType: {
    id: '',
    label: ''
  },
  category: [],
  state: '01',
  available: {
    state: '01',
    set: [
      { id: 'mon', name: '월', available: true, time: [{ from: '00:00', to: '24:00' }] },
      { id: 'tue', name: '화', available: true, time: [{ from: '00:00', to: '24:00' }] },
      { id: 'wed', name: '수', available: true, time: [{ from: '00:00', to: '24:00' }] },
      { id: 'thu', name: '목', available: true, time: [{ from: '00:00', to: '24:00' }] },
      { id: 'fri', name: '금', available: true, time: [{ from: '00:00', to: '24:00' }] },
      { id: 'sat', name: '토', available: true, time: [{ from: '00:00', to: '24:00' }] },
      { id: 'sun', name: '일', available: true, time: [{ from: '00:00', to: '24:00' }] }
    ]
  },
  thumbnail: '',
  responsive: 'mobile',
  noTranslateLangs: []
}

export default {
  name: 'pageitem',
  props: [
    'locale',
    'id',
    'oId', // 복사일 때 origin id 함께 받음
    'template', // boolean, true이면 복사로만 접근 가능함 (원본 수정/삭제 불가)
    'main',
    'isIdle'
  ],
  components: {
    Editor,
    SetPageItem
  },
  computed: {
    ...mapGetters({
      getSetting: 'setting/getData',
      submitPage: 'page/submitData',
      pageList: 'page/list',
      authInfo: 'authentication/getAuthInfo',
      checkedCategory: 'category/getChecked'
    }),
    // basic 사이트는 페이지 생성 최대 3개까지 가능
    pageLimit () {
      const isBasic = this.authInfo.sitePlan === 'basic'
      return isBasic && this.pageList.length >= 3
    },
    // 버튼의 전송기능은 premium만 가능 (정책변경으로 모두 사용가능)
    /*
    submitLimit () {
      return this.authInfo.sitePlan !== 'premium'
    },
    */
    isCopy () {
      return typeof (this.oId) !== 'undefined'
    },
    newItem () {
      return typeof (this.id) === 'undefined' && !this.isCopy
    },
    langData () {
      return this.getSetting.lang
    },
    text () {
      return {
        save: this.newItem || this.isCopy ? this.locale.save : this.locale.modify
      }
    },
    submitModules () {
      function findSubmit (arr) {
        const submits = []
        if (arr) {
          arr.forEach(function (x) {
            x.dataSet.column.forEach(function (xx) {
              if (xx.type === 'button' && xx.detail.button.type === 'submit') {
                submits.push(x.id)
              }
            })
          })
        }
        return submits
      }
      return findSubmit(this.itemModule).concat(findSubmit(this.mobileModule)).concat(findSubmit(this.tabletModule))
    },
    getDeviceSize () {
      const device = this.pageInfo.responsive
      const orient = this.orient ? 'portrait' : 'landscape'
      return this.deviceSize[device][orient]
    }
  },
  watch: {
    '$route' (to, from, next) {
      this.init()
    },
    /*
    itemModule: {
      deep: true,
      handler (content) {
        const device = this.pageInfo.responsive
        if (device === 'mobile') {
          this.mobileModule = this._.cloneDeep(content)
        } else if (device === 'tablet') {
          this.tabletModule = this._.cloneDeep(content)
        }
      }
    },
    */
    langData: {
      deep: true,
      handler (lang) {
        if (this.copied) {
          this.copied = false
        }
      }
    },
    submitModules (submits) {
      if (submits.length === 0) {
        this.$store.commit('page/initSubmit')
      }
    }
  },
  data () {
    return {
      originVer: 0,
      lastVer: 0,
      isForce: false,
      comment: null,
      dirtyFlag: false,
      itemModule: [],
      tabletModule: null,
      mobileModule: null,
      pageInfo: this._.cloneDeep(defaultInfo),
      copied: false,
      noFrame: false,
      isFold: false,
      linkedProduct: false,
      displayHideModes: false,
      deviceSize: {
        mobile: {
          landscape: '678*375',
          portrait: '375*678'
        },
        tablet: {
          landscape: '1024*768',
          portrait: '768*1024'
        }
      },
      orient: true /* true: portrait, false: landscape */
    }
  },
  created () {
    window.addEventListener('beforeunload', (e) => {
      if (this.dirtyFlag) {
        e.returnValue = '\\o/'
      }
    })
    this.removeDocumentClassAll()
    this.$store.dispatch('page/setPageListData')
    this.$store.commit('category/updateChecked', [])
  },
  beforeDestroy: function () {
    this.itemModule = null
    this.pageInfo = null
    this.removeDocumentClassAll()
    delete this.itemModule
    delete this.pageInfo
  },
  mounted () {
    this.init()
  },
  beforeRouteLeave (to, from, next) {
    const tryLogout = to.name === 'login'
    if (this.dirtyFlag && !this.isIdle && !tryLogout) {
      if (window.confirm(`${this.locale.confirm_leave}\n${this.locale.warn_leave}`)) {
        next()
      } else {
        next(false)
      }
    } else {
      next()
    }
  },
  methods: {
    ...mapActions([
      'page/addList'
    ]),
    track () {
      const site = this.$store.state.authentication.userInfo.siteid
      const routerPath = this.$route.path
      const path = `${site}${routerPath}`
      const title = `page - ${this.pageInfo.title}`
      this.$gtag.pageview({
        page_path: path,
        page_title: title
      })
    },
    saveMemo (memo) {
      this.comment = memo
      this.onSave()
    },
    removeDocumentClassAll () {
      const docsClass = document.body.classList
      docsClass.forEach(function (x) {
        document.body.classList.remove(x)
      })
    },
    foldUi () {
      this.isFold = !this.isFold
    },
    flagOn () {
      this.dirtyFlag = true
    },
    async init () {
      this.dirtyFlag = false
      this.$store.commit('onLoading', true)
      this.$store.dispatch('superadmin/getCategory')
      this.$store.commit('page/initSubmit')
      this.$store.dispatch('util/getSupportPlu')
      if (!this.newItem) {
        const pageId = this.isCopy ? this.oId : this.id
        const isTemplate = this.template
        if (isTemplate) {
          await this.$store.dispatch('page/getTemplateItem', pageId).then((res) => {
            this.getItem(res)
          })
          this.$store.commit('onLoading', false)
        } else {
          await this.getPageItem(pageId)
          this.$store.commit('onLoading', false)
        }
      } else {
        if (this.$store.state.authentication.userInfo !== null) {
          this.track()
        }
        this.$store.commit('onLoading', false)
      }
    },
    /**
     * version: 해당 페이지의 특정 버전이 필요할 때
     * site: 다른 사이트의 다른 페이지를 불러올 때
     */
    async getPageItem (pageId, version, site) {
      await this.$store.dispatch('versionhistory/getFile', {
        file: `page/item/${pageId}.json`,
        ...version && {
          version: version
        },
        ...site && {
          site: site
        }
      }).then((res) => {
        if (res && res.data) {
          this.getItem(res.data).then(() => {
            if (res.origin_version) {
              this.originVer = res.origin_version
            }
            if (res.last_version) {
              this.lastVer = res.last_version
            }
            if (this.$store.state.authentication.userInfo !== null) {
              this.track()
            }
            return true
          })
        } else {
          alert(this.locale.data_not_found)
          this.$router.replace('/')
        }
      })
    },
    checkFrameMode () {
      this.copied = false
    },
    copyToClipboard (id) {
      const baseUrl = window.location.origin
      const siteid = this.$store.state.authentication.userInfo.siteid
      const lang = this.langData.current
      const hasFrame = this.noFrame ? '&frame=false' : ''
      const pageUrl = `${baseUrl}/viewer/index.html?site=${siteid}${hasFrame}#/${lang}/page/${id}`
      UTIL.copyToClipboard(pageUrl)
      this.copied = true
      alert(this.locale.complete_copy_url)
    },
    updateModule (data) {
      this.itemModule = data
    },
    updateColumn (data) {
      const mods = this.itemModule.find(x => x.id === data.id)
      mods.dataSet.column = data.column
    },
    copyToDevice (copyTo, data) {
      this[copyTo].push(data)
    },
    updateResponsive (mode) {
      const toggle = mode === 'tablet' ? 'add' : 'remove'
      document.body.classList[toggle]('editMode')
      document.body.classList[toggle]('tabletMode')
      this.pageInfo.responsive = mode
      if (mode === 'tablet') {
        this.setOrient('landscape')
        this.mobileModule = this._.cloneDeep(this.itemModule)
        this.itemModule = this._.cloneDeep(this.tabletModule || this.itemModule)
      } else if (mode === 'mobile') {
        this.setOrient('portrait')
        this.tabletModule = this._.cloneDeep(this.itemModule)
        this.itemModule = this._.cloneDeep(this.mobileModule || this.itemModule)
      }
    },
    updateNoTranslateLangs (lang, isChecked) {
      if (isChecked) {
        this.pageInfo.noTranslateLangs = [...new Set([...this.pageInfo.noTranslateLangs, lang])]
      } else {
        this.pageInfo.noTranslateLangs = this.pageInfo.noTranslateLangs.filter(v => v !== lang)
      }
    },
    setOrient (orient) {
      const remove = orient === 'landscape' ? 'portrait' : 'landscape'
      this.orient = orient === 'portrait'
      document.body.classList.remove(remove)
      document.body.classList.add(orient)
    },
    displayHideMods (isChecked) {
      this.displayHideModes = isChecked
    },
    uploadThumbnail (e) {
      const data = {
        id: UNIQUE.mid(),
        file: e.target.files[0]
      }
      const isImage = regExp.image.test(data.file.name.slice(data.file.name.lastIndexOf('.') + 1).toLowerCase())
      if (isImage) {
        this.$store.dispatch('util/uploadFile', data).then((res) => {
          const imgsrc = res.source
          this.pageInfo.thumbnail = imgsrc
          e.target.value = ''
        })
      } else {
        alert(this.locale.validate_upload_image)
      }
    },
    deleteThumbnail () {
      if (window.confirm(this.locale.confirm_delete_image)) {
        this.pageInfo.thumbnail = ''
      }
    },
    async getItem (data) {
      const filteredLanguageValues = this.$store.getters['util/filteredLanguageValues']
      // column detail 중 radius 값을 제외해야 하는 타입
      const noRadius = /instagramfeed/
      // column간 위치변경을 위한 columnId 추가
      const setModuleColumns = function (moduleData) {
        let modules = moduleData.map(x => x) || []
        modules.forEach(function (x) {
          const columns = x.dataSet.column
          const setting = x.setting
          function uniqueArr (arr) {
            return [...new Set(arr)]
          }
          columns.forEach(function (c) {
            if (c.value && (c.type === 'text' || c.type === 'button')) {
              c.value = filteredLanguageValues(c.value)
            }
            if (c.columnId === undefined) {
              c.columnId = UNIQUE.mid()
            }
            if (c.type === 'qrcode' && !c.detail?.qrcodeExpired) {
              c.detail = {
                ...c.detail,
                options: [
                  ...c.detail.options,
                  'qrcodeExpired'
                ],
                qrcodeExpired: {
                  isActive: false,
                  day: 1
                }
              }
            }
            if (c.detail) {
              c.detail = {
                ...c.detail,
                options: uniqueArr([
                  ...c.detail.options,
                  !noRadius.test(c.detail.type) && 'radius'
                ]),
                ...!noRadius.test(c.detail.type) && {
                  radius: c.detail.radius || {
                    active: false,
                    tl: '8',
                    tr: '8',
                    br: '8',
                    bl: '8'
                  }
                }
              }
            }
          })
          if (setting.layout) {
            setting.layout = {
              ...setting.layout,
              ...!setting.layout.fullsize && {
                fullsize: {
                  active: false,
                  alignItems: 'center'
                },
                options: [
                  ...setting.layout.options,
                  'fullsize'
                ]
              }
            }
          }
          if (setting.action?.label) {
            setting.action.label = filteredLanguageValues(setting.action.label)
          }
          if (setting.action?.itemDefault?.label) {
            setting.action.itemDefault.label = filteredLanguageValues(setting.action.itemDefault.label)
          }
          if (setting.action?.item?.length > 0) {
            setting.action.item.forEach(opt => {
              if (opt.label) {
                opt.label = filteredLanguageValues(opt.label)
              }
            })
          }
        })
        return modules
      }
      const responsiveModule = this.pageInfo.responsive === 'mobile' ? 'mobileModule' : 'tabletModule'
      this.itemModule = setModuleColumns(data[responsiveModule] || data.module)
      this.pageInfo = {
        title: this.isCopy ? `${data.title} copy` : data.title,
        pId: data.pId || '',
        pIdActive: data.pIdActive,
        pIdType: data.pIdType || { id: '', label: '' },
        pIdTypeId: data.pIdTypeId || '',
        created: data.created,
        category: data.category,
        state: data.state,
        available: data.available,
        thumbnail: data.thumbnail || '',
        responsive: this.pageInfo.responsive || 'mobile',
        product_link: data.product_link,
        product_list: data.product_list,
        product_item: data.product_item,
        product_name: data.product_name,
        guestType: data.guestType,
        requiredAuth: data.requiredAuth || false,
        requiredAuthIdHidden: data.requiredAuthIdHidden || false,
        requiredAuthId: data.requiredAuthId || '',
        noTranslateLangs: data.noTranslateLangs || []
      }
      if (data.product_link && data.product_list && data.product_item) {
        this.$store.dispatch('product/getProductItem', data.product_list).then((res) => {
          const item = res.items?.find(x => x.id === data.product_item)
          if (item) {
            const info = {
              product_list: data.product_list,
              product_item: data.product_item,
              product_name: data.product_name,
              available: item.available,
              thumbnail: item.thumb,
              price: item.info.price,
              min: item.info.min,
              max: item.info.max
            }
            const submit = {
              cart: true,
              isSubmit: true,
              submitTo: item.submitTo,
              submitLabel: item.info.pName,
              subject: item.info.name
            }
            this.updateLoadProduct(info)
            this.$store.dispatch('page/setSubmit', submit)
          }
        })
      }
      if (data.tabletModule) this.tabletModule = setModuleColumns(data.tabletModule)
      this.mobileModule = setModuleColumns(data.mobileModule)
      this.$store.commit('category/updateChecked', data.category)
      if (data.submit) {
        this.$store.dispatch('page/setSubmit', data.submit)
      }
      return true
    },
    async checkPageLimit () {
      let pageLimit = false
      await this.$store.dispatch('page/setPageListData')
      pageLimit = this.pageList.length >= 3
      return pageLimit
    },
    // 상품 불러오기
    updateLoadProduct (data) {
      // 수량모듈에 데이터 덮어쓰기
      const quantity = this.itemModule.find(x => x.name === 'quantity')
      const button = this.itemModule.find(x => x.name.includes('button') && x.dataSet.column.find(c => c.detail.button.type === 'submit'))
      Object.keys(data).forEach(x => {
        if (!(x === 'price' || x === 'min' || x === 'max')) {
          this.pageInfo[x] = data[x]
        }
      })
      if (quantity) {
        quantity.setting.action.price.isPrice = true
        quantity.setting.action.price.value = data.price
        quantity.setting.action.min = data.min
        quantity.setting.action.max = data.max
      // 수량버튼 없으면 생성
      } else {
        const quantityModule = Object.values(modules).find(x => x.name === 'quantity')
        const mods = this._.cloneDeep(quantityModule)
        mods.id = UNIQUE.mid()
        mods.setting.action.price.isPrice = true
        mods.setting.action.price.value = data.price
        mods.setting.action.min = data.min
        mods.setting.action.max = data.max
        this.itemModule.push(mods)
      }
      // 전송버튼 없으면 생성
      if (!button) {
        const buttonModule = Object.values(modules).find(x => x.name === 'button1')
        const mods = this._.cloneDeep(buttonModule)
        mods.dataSet.column[0].detail.button.type = 'submit'
        mods.id = UNIQUE.mid()
        this.itemModule.push(mods)
      }
      this.linkedProduct = true
    },
    isLoadProduct (isLinked) {
      this.linkedProduct = isLinked
    },
    async loadVersion (version, site, id) {
      const pageId = id || this.id
      this.$store.commit('onLoading', true)
      await this.getPageItem(pageId, version, site)
      this.$store.commit('onLoading', false)
    },
    // 전송카테고리 필수선택여부 검사 (관리자 설정에서)
    validateSubmit () {
      let result = true
      const isSubmit = this.submitPage.isSubmit
      const isCheck = this.$store.state.admin.submitCateCheck
      function isBlank (str) {
        return str ? regExp.replaceAllEmpty(str).length > 0 : false
      }
      if (isSubmit && isCheck) {
        const categories = this.$store.state.admin.submitCategory.map(x => x.id)
        result = this.submitPage.submitCategory ? isBlank(this.submitPage.submitCategory.id) && categories.includes(this.submitPage.submitCategory.id) : false
      }
      return result
    },
    // 식별코드(pId) 필수입력여부 검사 (관리자 설정에서)
    validatePids () {
      let result = true
      const isSubmit = this.submitPage.isSubmit
      const isCheck = this.$store.state.admin.pidCheck
      function isBlank (str) {
        return str ? regExp.replaceAllEmpty(str).length > 0 : false
      }
      if (isSubmit && isCheck) {
        let checkList = []
        const pIdTypes = this.$store.state.admin.pidType.map(x => x.id)
        const name = /radio|checkbox|select/
        const options = this.itemModule.filter(x => x.type === 'action' && name.test(x.name) &&
         x.setting.action && x.setting.action.item && x.setting.action.item.filter(o => o.pIdActive).length > 0)
        if (this.pageInfo.pIdActive) {
          const page = {
            pId: this.pageInfo.pId,
            pIdType: this.pageInfo.pIdType
          }
          checkList.push(page)
        }
        if (options.length) {
          options.map(x => {
            return x.setting.action.item.filter(o => o.pIdActive).forEach(o => {
              checkList.push({
                pId: o.pId,
                pIdType: o.pIdType
              })
            })
          })
          // checkList = checkList.concat(optionList)
        }
        result = checkList.filter(x => {
          return !(x.pId && isBlank(x.pId) && x.pIdType && isBlank(x.pIdType.id) && pIdTypes.includes(x.pIdType.id))
        }).length === 0
      }
      return result
    },
    validateOnSave () {
      if ((this.newItem || this.isCopy) && this.pageLimit && this.checkPageLimit()) {
        alert(this.locale.page_create_limit)
        return false
      } else if (this._.isEmpty(this.itemModule)) {
        alert(this.locale.validate_page_save_empty)
        return false
      } else if (this.pageInfo.title === '') {
        alert(this.locale.validate_page_save_title)
        return false
      } else if (this.submitPage.isSubmit && this.submitPage.submitTo.trim() === '') {
        alert(this.locale.validate_page_save_submit)
        return false
      } else if (!this.validatePids()) {
        alert(this.locale.validate_pidtype_empty)
        return false
      } else if (!this.validateSubmit()) {
        alert(this.locale.validate_submitcategory_empty)
        return false
      } else {
        return true
      }
    },
    async onSave () {
      const isPassed = this.validateOnSave()
      if (isPassed) {
        const siteid = this.$store.state.authentication.userInfo.siteid
        const id = this.newItem || this.isCopy ? `${siteid}.${UNIQUE.mid()}` : this.id
        const data = {
          title: this.pageInfo.title,
          pId: this.pageInfo.pId,
          pIdActive: this.pageInfo.pIdActive,
          pIdType: this.pageInfo.pIdType,
          pIdTypeId: this.pageInfo.pIdTypeId,
          created: this.newItem ? new Date().toISOString() : this.pageInfo.created,
          updated: new Date().toISOString(),
          category: this.checkedCategory,
          state: this.pageInfo.state,
          available: this.pageInfo.available,
          submit: this.submitPage,
          module: this.pageInfo.responsive === 'mobile'
            ? this.tabletModule
              ? this.mobileModule || this.itemModule
              : this.itemModule
            : (this.tabletModule || this.itemModule) || this.itemModule,
          thumbnail: this.pageInfo.thumbnail,
          tabletModule: this.pageInfo.responsive === 'tablet' ? this.itemModule : this.tabletModule,
          mobileModule: this.pageInfo.responsive === 'mobile' ? this.itemModule : this.mobileModule,
          product_link: this.pageInfo.product_link,
          product_list: this.pageInfo.product_list,
          product_item: this.pageInfo.product_item,
          product_name: this.pageInfo.product_name,
          guestType: this.pageInfo.guestType,
          requiredAuth: this.pageInfo.requiredAuth,
          requiredAuthIdHidden: this.pageInfo.requiredAuthIdHidden,
          requiredAuthId: this.pageInfo.requiredAuthId,
          noTranslateLangs: this.pageInfo.noTranslateLangs || []
        }
        const pageData = {
          id: id,
          data: data
        }
        const pageListData = {
          id: id,
          title: data.title,
          pId: data.pId,
          created: data.created,
          updated: data.updated,
          state: data.state,
          submit: data.submit.isSubmit ? data.submit : null,
          category: data.category.length ? data.category : null,
          thumbnail: this.pageInfo.thumbnail,
          ...data.pIdActive && {
            pIdType: data.pIdType
          },
          ...data.requiredAuth && {
            requiredAuth: data.requiredAuth
          }
        }
        this.$store.commit('onLoading', true)
        this.$store.dispatch('versionhistory/setFile', {
          file: `page/item/${pageData.id}.json`,
          data: pageData.data,
          origin_version: this.originVer,
          last_version: this.lastVer,
          ...this.isForce && {
            force: this.isForce
          },
          ...this.comment && {
            comment: this.comment
          }
        }).then((res) => {
          // save page list
          const setPageListData = this.newItem || this.isCopy ? 'page/setPageListItem' : 'page/updatePageListItem'
          if (res && res.status) {
            if (res.status === 200) {
              // 리스트 업데이트
              this.$store.dispatch(setPageListData, pageListData).then(() => {
                this.$store.dispatch('page/setPageListData')
                this.dirtyFlag = false
                // 페이지 새로 로드
                this.getPageItem(pageData.id).then(() => {
                  this.$store.commit('onLoading', false)
                  alert(this.locale.complete_save)
                  this.$router.replace({ name: 'pageItem', params: { id: pageData.id } })
                })
              })
            } else if (res.status === 201) {
              if (window.confirm(this.locale.nothing_changed)) {
                this.$store.commit('onLoading', false)
              }
            } else if (res.status === 202) {
              if (window.confirm(`${this.locale.already_other_saved}\n${this.locale.ask_save_force}`)) {
                this.isForce = true
                this.$store.commit('onLoading', false)
                this.onSave()
              }
            }
          } else {
            alert(this.locale.unknown_error)
            this.$store.commit('onLoading', false)
          }
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
#editContent.columnContainer {
  padding-top: 30px;
}
</style>
